import React from "react";
import Slide from "@material-ui/core/Slide";
import { Zoom } from "react-toastify";

export const formatDateTime = (string) => {
  var options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(string).toLocaleTimeString([], options);
};

export const toastOptions = {
  transition: Zoom,
  position: "bottom-right",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
};

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export const getServerDomain = () => {
  return process.env.REACT_APP_ENVIRONMENT === "production"
    ? process.env.REACT_APP_SERVER_DOMAIN
    : "";
};
